var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c(
        "div",
        { staticClass: "search-term" },
        [
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.searchInfo }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "店铺名称" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "搜索条件" },
                      model: {
                        value: _vm.searchInfo.sellerId,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "sellerId", $$v)
                        },
                        expression: "searchInfo.sellerId"
                      }
                    },
                    _vm._l(_vm.sellerOptions, function(item) {
                      return _c("el-option", {
                        key: item.sellerId,
                        attrs: { label: item.sellerName, value: item.sellerId }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品详情名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索条件", clearable: "" },
                    model: {
                      value: _vm.searchInfo.goodsDetailTitle,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "goodsDetailTitle", $$v)
                      },
                      expression: "searchInfo.goodsDetailTitle"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "spu编号" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索条件", clearable: "" },
                    model: {
                      value: _vm.searchInfo.spuNo,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "spuNo", $$v)
                      },
                      expression: "searchInfo.spuNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "活动类型" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择"
                      },
                      model: {
                        value: _vm.searchInfo.activityTypes,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "activityTypes", $$v)
                        },
                        expression: "searchInfo.activityTypes"
                      }
                    },
                    [
                      _c(
                        "el-option",
                        { key: "1", attrs: { label: "返券", value: "1" } },
                        [_vm._v("返券")]
                      ),
                      _c(
                        "el-option",
                        { key: "2", attrs: { label: "返积分", value: "2" } },
                        [_vm._v("返积分")]
                      ),
                      _c(
                        "el-option",
                        { key: "-1", attrs: { label: "无活动", value: "-1" } },
                        [_vm._v("无活动")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "是否热卖" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择"
                      },
                      model: {
                        value: _vm.searchInfo.isHot,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "isHot", $$v)
                        },
                        expression: "searchInfo.isHot"
                      }
                    },
                    [
                      _c(
                        "el-option",
                        { key: 1, attrs: { label: "是", value: 1 } },
                        [_vm._v("是")]
                      ),
                      _c(
                        "el-option",
                        { key: 2, attrs: { label: "否", value: 2 } },
                        [_vm._v("否")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "是否推荐" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择"
                      },
                      model: {
                        value: _vm.searchInfo.isRecommend,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "isRecommend", $$v)
                        },
                        expression: "searchInfo.isRecommend"
                      }
                    },
                    [
                      _c(
                        "el-option",
                        { key: 1, attrs: { label: "是", value: 1 } },
                        [_vm._v("是")]
                      ),
                      _c(
                        "el-option",
                        { key: 2, attrs: { label: "否", value: 2 } },
                        [_vm._v("否")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择"
                      },
                      model: {
                        value: _vm.searchInfo.showStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "showStatus", $$v)
                        },
                        expression: "searchInfo.showStatus"
                      }
                    },
                    [
                      _c(
                        "el-option",
                        { key: 1, attrs: { label: "上架", value: 1 } },
                        [_vm._v("上架")]
                      ),
                      _c(
                        "el-option",
                        { key: 2, attrs: { label: "下架", value: 2 } },
                        [_vm._v("下架")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("查询")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置")
                  ])
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onAdd } },
                    [_vm._v("新增")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onDownload }
                    },
                    [_vm._v("模板下载")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-upload",
                    {
                      attrs: {
                        action: _vm.path + "/onlineshop/goods/batch/create",
                        headers: { "x-token": _vm.token },
                        "on-success": _vm.onUplodResponse,
                        "show-file-list": false
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            size: "small",
                            type: "primary",
                            icon: "el-icon-upload2"
                          }
                        },
                        [_vm._v("导入")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticClass: "online-shop-goods-table",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "tooltip-effect": "dark",
            height: "calc(100vh - 28rem)",
            "row-key": _vm.getRowKey,
            "expand-row-keys": _vm.expandRowKeys
          },
          on: { "row-click": _vm.onRowClick }
        },
        [
          _c("el-table-column", {
            attrs: { label: "", align: "right", type: "expand" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return _vm._l(props.row.relationSpuNoList, function(
                    item,
                    index
                  ) {
                    return _c(
                      "div",
                      { staticClass: "table-expand-item bairun-grey-bg" },
                      [
                        _c("div", { staticClass: "flex" }, [
                          _c(
                            "div",
                            { staticClass: "goods-logo" },
                            [
                              _c("el-image", {
                                attrs: {
                                  src: item.imgUrl,
                                  fit: "contain",
                                  "preview-src-list": [item.imgUrl]
                                }
                              })
                            ],
                            1
                          ),
                          _c("div", { staticClass: "table-goods-info" }, [
                            _c(
                              "div",
                              { staticClass: "bairun-table-goods-name" },
                              [_vm._v(_vm._s(item.goodsName))]
                            ),
                            _c("div", [_vm._v(_vm._s(item.titleSub))]),
                            _c("div", [_vm._v(_vm._s(item.spuNo))]),
                            _c("div", [
                              _vm._v("库存：" + _vm._s(item.goodsStock))
                            ]),
                            _c("div", [
                              _vm._v("成本：¥" + _vm._s(item.goodsCost))
                            ]),
                            _c("div", { staticClass: "goods-price" }, [
                              _vm._v("售价：" + _vm._s(item.goodsPrice))
                            ])
                          ])
                        ])
                      ]
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "店铺名称", prop: "sellerId" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("getSellerName")(scope.row.sellerId)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "默认spu图标", width: "100", align: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("el-image", {
                      attrs: {
                        src: scope.row.imgUrl,
                        fit: "contain",
                        "preview-src-list": [scope.row.imgUrl]
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "商品详情名称", width: "400" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", { staticClass: "table-goods-info" }, [
                      _c("div", { staticClass: "bairun-table-goods-name" }, [
                        _vm._v(_vm._s(scope.row.goodsDetailTitle))
                      ]),
                      _c(
                        "div",
                        [
                          _vm._v("编号："),
                          _c(
                            "el-link",
                            {
                              attrs: { underline: true },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.onCopy(
                                    scope.row.goodsDetailNo + ""
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(scope.row.goodsDetailNo))]
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          scope.row.isHot == 1
                            ? _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: "danger",
                                    size: "mini",
                                    effect: "plain"
                                  }
                                },
                                [_vm._v("热卖")]
                              )
                            : _vm._e(),
                          _vm._v("   "),
                          scope.row.isRecommend == 1
                            ? _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: "primary",
                                    size: "mini",
                                    effect: "plain"
                                  }
                                },
                                [_vm._v("推荐")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "bairun-rotate-tag" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("getActivityTypes")(scope.row.activityTypes)
                          )
                        )
                      ])
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "小程序路径" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-link",
                      {
                        attrs: { underline: true },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.onCopy(
                              "/pagesA/bairun-goods-detail/bairun-goods-detail?goodsDetailNo=" +
                                scope.row.goodsDetailNo
                            )
                          }
                        }
                      },
                      [_vm._v("点击复制")]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "所属类目", prop: "categoryName" }
          }),
          _c("el-table-column", {
            attrs: { label: "专区会场" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("getShowAreaList")(scope.row.showAreaList)
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "提货方式", prop: "logisticsTypes" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.logisticsTypes == "1"
                      ? _c("span", [_vm._v("门店自提")])
                      : _vm._e(),
                    scope.row.logisticsTypes == "2"
                      ? _c("span", [_vm._v("包邮")])
                      : _vm._e(),
                    scope.row.logisticsTypes == "1,2"
                      ? _c("span", [_vm._v("包邮或门店自提")])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "排序", prop: "weight" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_vm._v(" " + _vm._s(scope.row.weight) + " ")]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "状态", prop: "showStatus" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.showStatus == 1
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              effect: "plain"
                            }
                          },
                          [_vm._v("已上架")]
                        )
                      : _vm._e(),
                    scope.row.showStatus == 2
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "danger",
                              size: "mini",
                              effect: "plain"
                            }
                          },
                          [_vm._v("已下架")]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "上架时间", prop: "showAt", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.showAt)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.onUpdate(scope.row)
                          }
                        }
                      },
                      [_vm._v("变更")]
                    ),
                    _c(
                      "el-dropdown",
                      {
                        staticClass: "bairun-margin-l",
                        attrs: { trigger: "click" },
                        on: { command: _vm.handleCommand }
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small" }
                          },
                          [
                            _vm._v("更多"),
                            _c("i", {
                              staticClass: "el-icon-arrow-down el-icon--right"
                            })
                          ]
                        ),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  icon: "el-icon-edit",
                                  command: {
                                    action: "updateStatus",
                                    updateStatus: 1,
                                    row: scope.row
                                  }
                                }
                              },
                              [_vm._v("上架")]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  icon: "el-icon-edit",
                                  command: {
                                    action: "updateStatus",
                                    updateStatus: 2,
                                    row: scope.row
                                  }
                                }
                              },
                              [_vm._v("下架")]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  icon: "el-icon-delete",
                                  command: { action: "delete", row: scope.row }
                                }
                              },
                              [_vm._v("删除")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10, 30, 50, 100],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }